// src/main.ts
import { bootstrapApplication } from '@angular/platform-browser';
import { AppComponent } from './app/app.component';
import { appConfig } from './app/app.config';

// Capturar Promise rejections no manejadas ANTES del bootstrap.
// Después del bootstrap, el GlobalErrorHandler toma el control.
// Este handler cubre el periodo entre la carga de main.ts y la inicialización de DI.
window.addEventListener('unhandledrejection', (event: PromiseRejectionEvent) => {
  // Suprimir el error en la consola para no exponer detalles técnicos
  // (GlobalErrorHandler lo enviará al LoggerService cuando esté disponible)
  event.preventDefault();
  console.error('[BEL] Promise rejection no manejada:', event.reason);
});

bootstrapApplication(AppComponent, appConfig).catch((err: unknown) => {
  // Si el bootstrap falla (ej: APP_INITIALIZER rechazado por config inválida),
  // el error ya fue manejado por ConfigService.load() que muestra el mensaje
  // en #app-loading. Aquí solo lo registramos en consola para el operador.
  console.error('[BEL] Error crítico en el bootstrap:', err);
});
